import { render, staticRenderFns } from "./DataBody1BAK.vue?vue&type=template&id=6170307f&"
import script from "./DataBody1BAK.vue?vue&type=script&lang=js&"
export * from "./DataBody1BAK.vue?vue&type=script&lang=js&"
import style0 from "./DataBody1BAK.vue?vue&type=style&index=0&id=6170307f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports